Directives.NetworkCommentsDirective = function NetworkCommentsDirective() {

    // @ngInject
    function NetworkCommentsDirectiveControllerFunc($scope, $injector, NetworkManager, AnalyticsService, _, moment, AppStates) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkCommentsDirectiveController';

        this.NetworkManager = NetworkManager;

        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.AnalyticsService = AnalyticsService;
        this._ = _;
        this.moment = moment;
        this.AppStates = AppStates;

        this.newComment = "";
        this.submittingComment = false;
        this.initializeCommentsHiding();
        
        this.lengthToShorten = 120;
        this.isExpanded = false;

        this.isOpportunity = this.activityObjectType === 'network_referral';

    }

    var NetworkCommentsDirectiveController = Class(Controllers.BaseController, {

        constructor: NetworkCommentsDirectiveControllerFunc,

        isShortenedComment: function isShortenedComment(comment) {
            return this.hideInitialComments &&
                   this.isLongComment(comment) &&
                   !this.isExpanded;
                   
        },
        
        isLongComment: function isLongComment(comment) {
            return comment.length > this.lengthToShorten;
        },

        submitNewComment: function submitNewComment() {

            if (!/^\s*$/.test(this.newComment)) { //comment not empty
                this.submittingComment = true;
                this.NetworkManager.addNewComment(this.activityObject, this.activityObjectType, this.newComment).then(
                    function success() {
                        this.newComment = "";
                        this.submittingComment = false;
                        this.mergeFeedItemUsers();
                        this.actionOnSuccess();
                    }.bind(this),
                    function error() {
                        this.submittingComment = false;
                    }.bind(this)
                );
            }
        },

        showInitialComments: function showInitialComments() {
           this.hideInitialComments = false;
        },

        initializeCommentsHiding: function initializeCommentsHiding() {
            if (this.activityObject.feed) {
                this.initializeComments();
            } else {
                this.activityObject.on('success', function () {
                    if (this.initialCommentsCount === undefined && this.activityObject.feed) {
                        this.initializeComments();
                    }
                }.bind(this));
            }
        },

        initializeComments: function initializeComments() {
            this.initialCommentsCount = this.activityObject.feed.feed_items.length;
            this.hideInitialComments = (this.initialCommentsCount > 1);
            this.mergeFeedItemUsers();
        },
        
        mergeFeedItemUsers: function mergeFeedItemUsers() {
            var feed_users = this.activityObject.feed.feed_users_info;
            this._.each(this.activityObject.feed.feed_items, function eachComment(feedItem) {
                if (feedItem.user === undefined) {

                    var user = this._.find(feed_users, function(feed_user) {
                        return feed_user._id === feedItem.sender_id;
                    });
                    feedItem.user = user;
                }
            });
        }

    });

    return {
        scope: {
            activityObject: "=",
            activityObjectType: "=",
            isPaused: "=",
            actionOnSuccess: '&'
        },
        templateUrl: 'angular/app/modules/network/features/comments/network_comments_directive_template.html',
        controller: NetworkCommentsDirectiveController,
        controllerAs: 'networkCommentsVm',
        bindToController: true
    };
};
